const fi = {
  common: {
    wallet: "lompakko",
    playPage: "pelaa",
    minTop: "minimisumma on $10",
    maxTop: "maksimisumma on $500",
    website: "verkkosivusto",
    signOut: "kirjaudu ulos",
    hidden: "piilotettu",
    victory: "voitto",
    wentWrong: "jotain meni pieleen, uudelleenohjataan",
    stakeLabel: "panos",
    howDoes: "miten tämä toimii?",
    continue: "Jatka",
    continueWithGoogle: "Jatka Googlen kautta",
    continueWithApple: "Jatka Applen kautta",
    termsOfService: "käyttöehdot",
    privacyPolicy: "tietosuojakäytäntö",
    termsOfServiceFooter: "käyttöehdot",
    privacyPolicyFooter: "tietosuojakäytäntö",
    verificationCode: "vahvistuskoodi",
    verify: "vahvista",
    account: "tili",
    error: "virhe tapahtui\n",
    checkBackLater: "tarkista myöhemmin uudelleen",
    looking: "etsitään...",
    yes: "kyllä",
    no: "ei",
    pleaseSelect: "Ole hyvä ja valitse\n",
    disclaimer: "jatkamalla hyväksyt meidän\n",
    and: "ja",
  },
  endOfGame: {
    wonByCheckmate: "voitti shakki-matilla",
    lostOnTime: "hävisi ajalla",
    resigns: "luovuttaa",
    gameDrawnByAgreement: "peli päättyi tasapeliin sopimuksen mukaan",
    abandonedTheGame: "hylkäsi pelin",
    gameAborted: "peli keskeytettiin",
    gameDrawnByStalemate: "peli päättyi pattitilanteeseen",
    gameDrawnByFiftyMoveRule: "peli päättyi viidenkymmenen siirron sääntöön",
    gameDrawnByInsufficientMaterial: "peli päättyi riittämättömän materiaalin vuoksi",
    gameDrawnByThreefoldRepetition: "peli päättyi kolminkertaiseen toistoon",
    draw: "tasapeli",
    victory: "voitto",
    defeat: "tappio",
    aborted: "keskeytetty",
    white: "valkoinen",
    black: "musta",
    inspectBoard: "näytä lauta",
    returnToEndOfGameModal: "jatka",
  },
  byPhone:{
    continueOnPhone: "jatka\npuhelimessa",
    or: "tai",
    continueOnWeb: "jatka\nselaimessa",
    disclaimer: "sopii, jos sinulla on henkilöllisyystodistuksesi kuva levyllä"
  },
  signUp: {
    email: "sähköposti",
    username: "käyttäjänimi",
    usernameInvalid: "käyttäjänimi on virheellinen",
    emailInvalid: "sähköposti on virheellinen",
    login: "kirjaudu sisään",
    continueWithPhone: "jatka puhelinnumerolla",
    tickBoxes: "ruksitaan joitakin\nruutuja",
    confirm: "Vahvistan, että\n",
    resideIn: "Asun\n",
    notPEP: "En ole poliittisesti vaikutusvaltainen henkilö (PEP), perheenjäsen tai tunnettu yhteistyökumppani\n",
    purpose: "Suhteeni tarkoitus ja luonne Gambit kanssa on yksinomaan palvelun käyttö viihteen vuoksi\n",
    soleBenefit: "Käytän palvelua ainoastaan omaksi hyödykseni, eikä muita hyödynsaajia ole\n",
  },
  identity: {
    beingVerified: "identiteetti\nvahvistetaan",
    verified: "vahvistettu\n",
    failed: "vahvistus\nepäonnistui",
  },
  payment: {
    failed: "maksu epäonnistui.\nyritä uudelleen",
    successful: "maksu\nonnistui!",
    toppedUp: "olet\nlatautunut!",
    topUp: "lataa\n",
    payWith: "maksa...\n",
  },
  gameplay: {
    play: "pelaa\n",
    challenge: "haastaa sinut",
    gameWorth: "pelin arvo\n",
    whatsYourNumber: "mikä on\nnumerosi?",
    receiveCode: "saat vahvistuskoodin\npiakkoin",
    matchedOpponent: "Sinut yhdistetään vastaavan tasoiselle vastustajalle.",
    stake: {
      total: "Kokonaispanos on alla valittu summa.",
      contribution: "Osallistut noin puolella tästä summasta.",
      weakerOpponent: "Jos vastustajasi on heikompi, maksat suuremman osan panoksesta.",
      strongerOpponent: "Jos vastustajasi on vahvempi, maksat pienemmän osan panoksesta.",
    },
    supportInfo: "Vieraile tukisivullamme saadaksesi lisätietoja.\n",
    continueBrowser: "jatka\nselaimessasi",
    continuePhone: "jatka\npuhelimessa",
    getStarted: "aloitetaan\n",
    sentText: "olemme lähettäneet sinulle\ntekstiviestin",
    enterReceivedCode: "syötä saamasi\nvahvistuskoodi",
    wrongCode: "väärä koodi, yritä uudelleen\n",
    secPerMove: "sekuntia/siirto",
    resign: {
      prompt: "oletko varma, että haluat luovuttaa?",
    },
    draw: {
      offer: "hyväksy tasapelitarjous?",
    },
    rating: "luokitus\n",
    balance: "saldo\n",
    rematch: "uusintaottelu\n",
    newOpponent: "uusi vastustaja\n",
    home: "koti\n",
    rematchOffer: "vastustajasi tarjoaa uusintaottelua. hyväksy?",
    leaveGame: "Olet parhaillaan pelaamassa peliä. Oletko varma, että haluat poistua?",
    room: "huone:\n",
    gameTypes: {
      bullet: {
        title: "bullet\n",
        description: "Adrenaliinia täynnä oleva shakki. Sinulle ja vastustajallesi annetaan vain 1 minuutti pelin voittamiseen.",
      },
      blitz: {
        title: "blitz\n",
        description: "Sinulle ja vastustajallesi annetaan 3 minuuttia pelin voittamiseen.",
      },
    },
    stakes: {
      unlockNext: "pelaa {amount} lisää pelejä avataksesi seuraavan panoksen",
      allUnlocked: "kaikki panokset avattu",
    },
    withdraw: "nosta\n",
  },
  puzzle: {
    begin: "aloittaa",
    next: "seuraava",
    unavailableInYourRegion: "ei saatavilla",
    puzzle: "arvoitus",
    whiteToPlay: "valkoinen pelaamaan",
    blackToPlay: "musta pelaamaan",
    time: "aika",
    solution: "ratkaisu",
    somethingWentWrong: "jotain meni pieleen",
    rating: "arvio",
    credits: "krediitit",
    puzzleFailed: "häviö",
    puzzleSolved: "voitto",
    correct: "oikea ratkaisu",
    incorrect: "väärä ratkaisu",
    youRanOutOfTime: "aikasi loppui",
    puzzleDescription: "Sinulla on 10 sekuntia + 2 sekuntia/siirto ratkaista arvoitus.",
    creditsLeft: "jäljellä olevat krediitit",
    refillIn: "täydennä",
    lastPuzzle: "tämä on viimeinen arvoituksesi, tarkista myöhemmin lisää.",
    outOfCredits: "krediittisi ovat loppuneet, tarkista myöhemmin.",
    locationPrompt: "Tarvitsemme sijaintisi jatkaaksemme. Jos se on estetty, ota se uudelleen käyttöön:",
    locationInstructions: "Napsauta osoiterivillä olevaa kuvaketta, valitse 'Salli aina' ja päivitä sivu",
    creditsError: "Virhe kredittien lataamisessa",
    moves: "Siirrot:",
  },
};

export {fi};
